import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import Catagorize from "../components/catagorize"
import { useStaticQuery, graphql } from "gatsby"
import { has, get } from "lodash"
import { notification } from "antd"
import { GoogleOutlined } from "@ant-design/icons"
import Img from "gatsby-image"
import Cookies from "universal-cookie"
import { extract_available_plugins } from "../functions"
// import { getTemplates } from "../api/index"

const firstCapital = str => {
  return str.substring(0, 1).toUpperCase() + str.substring(1, str.length)
}

const IndexPage = props => {
  const { pageContext } = props

  const cookies = new Cookies()

  let data = useStaticQuery(graphql`
    query temps {
      templates: allAirtable(filter: { table: { eq: "Templates" } }) {
        nodes {
          data {
            Title
            reqPlugins
            CSS
            published
            rawCode
            Catagory
            Screenshot {
              id
              url
              thumbnails {
                small {
                  url
                  width
                  height
                }
                large {
                  url
                  width
                  height
                }

                full {
                  url
                  width
                  height
                }
              }
            }
          }
          recordId
        }
      }
      promotionImage: file(relativePath: { eq: "promotion.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  useEffect(() => {
    if (
      cookies.get("promo-popup") !== "true" &&
      cookies.get("promo-displayed") !== "true"
    ) {
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)

      cookies.set("promo-displayed", "true", { expires: tomorrow })
      notification.open({
        message: (
          <span>
            <GoogleOutlined /> Browser Extension
          </span>
        ),
        description: (
          <div className="cwp-popup-chrome">
            <a
              href="https://chrome.google.com/webstore/detail/gutenberghub/pkjhekakadbpmpehgkdndgmpepphekbk"
              target="__blank"
            >
              <Img fluid={data.promotionImage.childImageSharp.fluid} />
            </a>
          </div>
        ),
        placement: "bottomRight",
        onClose: () =>
          cookies.set("promo-popup", "true", { expires: tomorrow }),
        duration: 1000000,
        className: "cwp-promotion-popup",
      })
    }
  }, [])

  const templates = !has(pageContext, "templates")
    ? data.templates.nodes
    : pageContext.templates


  return (
    <Layout currentCatag={get(pageContext, "catagory")}>
      {!has(pageContext, "templates") ? (
        <SEO title="Home" seoType="home" />
      ) : (
        <SEO
          title="Home"
          seoType="catagory"
          catagory={firstCapital(get(pageContext, "catagory"))}
        />
      )}

      <div className="cwp-home-header">
        <h1>Gutenberg Template Library</h1>
        <p>
          Collection of FREE Gutenberg Templates and block designs to help you
          create beautiful websites in WordPress easily. New Gutenberg templates
          are added regularly, make sure to check back for newly added
          templates.
        </p>
      </div>
      <Catagorize availablePlugins={extract_available_plugins(templates)} data={props} loading={false} templates={templates} />
    </Layout>
  )
}

export default IndexPage
